import { useState } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { IStations } from "../../../interfaces/endpoints/IStations";
import Localizations from "../../bundles/Localizations";
import Input from "../../ui/input/Input";
import TextArea from "../../ui/input/Textarea";

const MultpileLangFieldsStation = () => {
  const {
    register,
    formState: { errors },
    control
  } = useFormContext<IStations>();
  const { fields } = useFieldArray({
    control,
    name: "station.locales",
    keyName: "uuid"
  });

  const [langIdActive, setLangIdActive] = useState<1 | 2>(2);

  return (
    <div className="rounded-xl bg-gray-100 p-3 mb-6">
      <Localizations
        activeId={langIdActive}
        onChange={setLangIdActive}
        alError={!!errors.station?.locales?.[1]?.name}
        enError={!!errors.station?.locales?.[0]?.name}
      />
      <div className="overflow-hidden mt-2 -mx-2">
        <div
          className={`transform duration-500 transition-all w-full flex
    ${langIdActive === 1 ? "translate-x-0" : "-translate-x-full"}`}
        >
          {fields.map((localeField, index) => {
            return (
              <div key={localeField.uuid} className="w-full flex-none px-2">
                <Input
                  label="Emri i Stacionit*"
                  className="mb-2"
                  {...register(`station.locales.${index}.name`)}
                  placeholder="Shkruaj emrin e stacionit këtu..."
                  error={
                    errors.station?.locales &&
                    errors?.station?.locales[index]?.name?.message
                  }
                />
                <Controller
                  control={control}
                  name={`station.locales.${index}.description`}
                  defaultValue=""
                  render={({ field: descField }) => (
                    <TextArea
                      ref={descField.ref}
                      name={descField.name}
                      onBlur={descField.onBlur}
                      value={descField.value ?? ""}
                      onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                         descField.onChange(e.target.value)}
                      label="Përshkrimi (opsional)"
                      className="mb-1"
                      placeholder="Shkruaj përshkrimin e stacionit këtu..."
                      rows={3}
                    />
                  )}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MultpileLangFieldsStation;
